import { makeStyles } from 'tss-react/mui';
import { PRIMARY_PAYMENT_DARK, PRIMARY_PAYMENT_DEFAULT } from 'src/global/theme/colors';

export const styles = makeStyles()(() => {
    return {
        downloadButton: {
            height: '48px',
            padding: "4px 30px",
            minWidth: 'fit-content',
            backgroundColor: PRIMARY_PAYMENT_DEFAULT,

            '&:hover': {
                backgroundColor: PRIMARY_PAYMENT_DARK,
            }
        }
    }
});
